import uniqid from 'uniqid';
import { postSSTData } from '../helpers/sst/postSstData';
import { createSSTData } from '../helpers/sst/createSstData';

let tabId = '';
let visibility = document.visibilityState;

/**
 * Checks if there is an id in storage
 * if true, returns it and removes it from storage
 * else creates a new unique id
 */
const getTabIdFromStorageOrCreateNewOne = (): string => {
    const currentIdInStorage = window.sessionStorage.getItem('tabId');

    if (currentIdInStorage) {
        tabId = currentIdInStorage;
        window.sessionStorage.removeItem('tabId');
    } else tabId = uniqid('tabId-');

    return tabId;
};

const setTabIdInStorage = (): void => window.sessionStorage.setItem('tabId', tabId);

const sendTrackingInformationThroughWebWorker = (): void => {
    postSSTData(
        createSSTData({
            jsonPayload: {
                eventType: 'frontendTabBrowsing',
                elementType: 't9gElements',
                t9gElements: [
                    {
                        tabId,
                        visibilitystate: document.visibilityState,
                        url: window.location.href,
                    },
                ],
            },
        })
    );
};

/**
 * Tracks visibility change if previously saved visibility state doesn't match current visibility
 */
const checkVisibilityAndTrack = (): void => {
    if (visibility !== document.visibilityState) sendTrackingInformationThroughWebWorker();

    visibility = document.visibilityState;
};

const tabBrowsing = (): void => {
    tabId = getTabIdFromStorageOrCreateNewOne();
    visibility = document.visibilityState;

    sendTrackingInformationThroughWebWorker();

    window.addEventListener('beforeunload', setTabIdInStorage);
    window.addEventListener('visibilitychange', checkVisibilityAndTrack);
};

// no exports: processInclude() would invoke exported functions
tabBrowsing();
